import { submissionsService, type SubmissionsFilters } from "@/api/submissions.service";
import { useQuery } from "./useApi";

export function useSubmissions(filters?: SubmissionsFilters) {
  return useQuery(
    () => submissionsService.get(filters),
    [
      filters?.limit,
      filters?.offset,
      filters?.publicationId,
      filters?.regionId,
      filters?.edition,
      filters?.practiceAreaId,
      filters?.editionId,
      filters?.rankingEntityId,
      filters?.bpaId,
      filters?.taxonomy,
      filters?.search,
      filters?.sortField,
      filters?.sortDirection,
      // Joined so a fresh array with the same statuses doesn't refetch every render.
      filters?.contactMatchStatus?.join(","),
      filters?.verifiedFirmOnly,
    ],
  );
}
